import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($q, $state, AccountsResource, Alert) {
        this.$q = $q;
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    $onInit() {
        if (!this.accounts.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }

        this.st = new SmartTable();
    }

    remove() {
        const accountIds = this.accounts
            .filter(({isDisownable}) => isDisownable)
            .map(({id}) => id);

        this.isSaving = true;
        this.$q
            .all(accountIds.map(id => this.AccountsResource.removeAccountOwner(this.companyId, id)))
            .then(() => {
                const accounts = this.accountsForCompanyUser;
                const filteredAccounts = accounts.filter(({id}) => !accountIds.includes(id));
                accounts.splice(0, accounts.length, ...filteredAccounts);
                this.Alert('success', 'company.user-directories.manage-user.remove-accounts.removed');

                if (accounts.length) {
                    return this.$state.go('^');
                } else {
                    // When all accounts are deleted, company user is also deleted
                    return this.$state.go('company.user-directories.saaspass-users');
                }
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/remove-accounts/remove-accounts.controller.js